// extracted by mini-css-extract-plugin
module.exports = {"root":"info-chip_root__4lu1Z"};